angular.module('charts')
  .directive("reportBreadcrumbs", function () {
    return {
        restrict: "E",
        templateUrl: '/resources/charts/partials/report-breadcrumbs.html',
        controller: [
            '$scope',
            'navigation',
            function (
                $scope,
                navigation
            ) {
                $scope.breadcrumbClicked = function (item) {
                    // TODO: see if tryNavigate can be removed now that settings is on separate page
                    navigation.tryNavigate().then(function () {
                        navigation.goToItem(item);
                    });
                };

                $scope.infoHeaderClicked = function() {
                    navigation.goHome();
                };
            }
        ]
    };
});
